import React from 'react';
import RowCollapsed from '../assets/images/rowexpansioncollapsedicon.svg';

export default () => {
  return <img src={RowCollapsed} alt="" />;
};
